

export const normalize = (data, normalizeForm) => {
    return data.reduce((acc, item) => {
        acc.push(normalizeForm(item));
        return acc;
    }, [])
}